import axios from 'axios';
import fetch from './fetch.js';
import { IS_MOCK, MockURL, IS_KJMOCK } from '_libs/host'
let api_mock = IS_MOCK ? '' : 'api/'
let BASE_API = IS_MOCK ? MockURL : process.env.BASE_API

export default {
    // 地址信息
    getAreaCode(data) {
      let url = IS_MOCK ? '/getAreaCode' : BASE_API + '/api/getAreaCode'
      if (data && data.productId && data.productId != undefined && data.productId != 'undefined') {
        url += `?productId=${data.productId}`
      }
      return fetch({
        method: 'get',
        url,
        params: null,
        withCredentials: true
      })
    },
    getJsonFile (url, data) {
      let totalUrl = ''
      if (totalUrl.indexOf('?') > -1) {
        totalUrl = `${url}&version=${new Date().getTime()}`
      } else {
        totalUrl = `${url}?version=${new Date().getTime()}`
      }
      return fetch({
        method: 'get',
        url: totalUrl,
        params: data,
        withCredentials: false
      })
    },
    validPersonInfo(data) {
        return fetch({
            method: 'post',
            url: '/api/validPersonInfo',
            data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    // 安徽标签且非签约用户
    checkIfUserHasPolicyBonus(data) {
        return fetch({
            method: 'post',
            url: '/api/user/checkIfUserHasPolicyBonus',
            data: data,
            // headers: {
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    // 试算
    calPremium(data) {
        return fetch({
            method: 'post',
            url: '/api/order/calPremium',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    // 初始化计划
    initCalPremium(params) {
        return fetch({
            method: 'get',
            url: '/api/order/initCalPremium' + params,
            params: {},
        })
    },
    checkUserQualification(params) {
        if(IS_KJMOCK) return Promise.resolve();
        return fetch({
            method: 'get',
            url: api_mock+'main/checkUserQualification',
            params,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    // 人工确认
    checkProductWhiteList(data) {
      return fetch({
        method: 'get',
        url: '/api/order/checkProductWhiteList',
        params: data,
      })
    },
    // 人工确认 - 绑定待完善
    updateCheckProductWhiteUuid(data) {
        return fetch({
          method: 'get',
          url: '/api/order/updateCheckProductWhiteUuid',
          params: data,
        })
    },


    // setcookies(data) {
    //   return fetch({
    //     method: 'post',
    //     url: process.env.BASE_API + '/api/user/login/setCookie',
    //     data: data,
    //     headers: {
    //         'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
    //     },
    //     transformRequest: [function (data) {
    //         // Do whatever you want to transform the data
    //         let ret = ''
    //         for (let it in data) {
    //             ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
    //         }
    //         return ret
    //     }],
    //   })
    // },

    get(url) {
        return fetch({
            method: 'get',
            url: url,
            withCredentials: false,
        })
    },

    // getJson(url) {
    //     return fetch({
    //         method: 'get',
    //         url: url,
    //         withCredentials: false,
    //         baseURL: process.env.JSON_PATH,
    //     })
    // },

    /* 用户登录*/
    // getSms(data) {
    //     return fetch({
    //         method: 'get',
    //         url: '/api/user/get_sms',
    //         params: data,
    //     })
    // },
    getSms(data) {
      return fetch({
          method: 'get',
          url: '/oauth/captcha', //'/api/user/get_sms',
          params: data,
      })
    },
    login(data) {
      return fetch({
        method: 'post',
        url: '/oauth/login',
        data: data,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            // 'Authorization': utils.getCookie('token'),
        },
        transformRequest: [function (data) {
            // Do whatever you want to transform the data
            let ret = ''
            for (let it in data) {
                ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
            }
            return ret
        }],
    })
        // return fetch({
        //     method: 'post',
        //     url: '/api/user/login',
        //     data: data,
        //     headers: {
        //         'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
        //     },
        //     transformRequest: [function (data) {
        //         // Do whatever you want to transform the data
        //         let ret = ''
        //         for (let it in data) {
        //             ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
        //         }
        //         return ret
        //     }],
        // })
    },
    getUserInfo(data) {
      return fetch({
        method: 'post',
        url: '/api/user/getUserInfo',
        data: data,
          // headers:{
          //   "Authorization": utils.getCookie('token'),
          // },
      })
        // return fetch({
        //     method: 'post',
        //     url: '/api/user/getUserInfo',
        //     data: data
        // })
    },

    autoLogin(data) {
        return fetch({
            method: 'post',
            url: '/api/group/autoLogin',
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                // 'Authorization': utils.getCookie('token'),
            },
            transformRequest: [function (data) {
                // Do whatever you want to transform the data
                let ret = ''
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
            }],

        })
    },
    logout() {
        return fetch({
          method: 'get',
          url: '/oauth/logout'
        })
        // return fetch({
        //     method: 'get',
        //     url: '/api/user/logout'
        // })
    },

    /* 获取产品列表 */
    getProductList(data) {
        return fetch({
            method: 'get',
            url: '/api/main/queryInsuranceTypeList',
            params: data,
            // headers: {
            //     'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
            //     'Authorization': utils.getCookie('token'),
            // }
        })
    },
    getProductList(data) {
        return fetch({
            method: 'post',
            url: '/api/main/queryInsuranceTypeList',
            data: data,
            // headers: {
            //     "Authorization": utils.getCookie('token'),
            // },
        })
    },
    getAllCompany(data) {
        return fetch({
            method: 'get',
            url: '/api/main/getAllCompany',
            params: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    getProductDetail(data) {
        // return fetch({
        //     method: 'get',
        //     url: '/api/insuranceChoose/' + data.productId,
        //     params: {},
        // })

        function getJJ() {
          return fetch({
              method: 'get',
              url: api_mock+'/insuranceChoose/' + data.productId,
              params: {}
          })
        }
        function getKJ() {
          return fetch({
              method: 'get',
              url: '/api/insuranceChoose/' + data.productId,
              params: {},
              //   headers:{
              //     "Authorization": utils.getCookie('token'),
              //   },
          })
        }
        return axios.all([
          getJJ(),
          getKJ(),
        ]).then(axios.spread(function(jjRes, kjRes){
          let productDetailJJ = jjRes
          let productDetailKj = kjRes
          //lml
          // console.log(productDetailJJ,productDetailKj)
          // console.log(JSON.parse(productDetailJJ.data.front.frontControlInfo))
          if (productDetailJJ.data) {
            productDetailJJ.data.activitys = productDetailKj.data.activitys
            productDetailJJ.data.missionSimpleInfos = productDetailKj.data.missionSimpleInfos
            productDetailJJ.data.premiumRateAudit = productDetailKj.data.premiumRateAudit
            productDetailJJ.data.premiumRateList = productDetailKj.data.premiumRateList
          }
          return Promise.resolve(productDetailJJ)
        }))
    },
    getClauseShowByPolicyUuid(data) {
        return fetch({
            method: 'get',
            url: '/api/getClauseShowByPolicyUuid',
            params: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
    },
    getInsureDayLimit(data) {
        return fetch({
            method: 'get',
            url: '/api/main/getInsureDayLimit/' + data.year,
            params: {},
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'
            }
        })
    },
    uploadImg(data) {
        return fetch({
            method: 'post',
            url: '/api/policy/uploadSingleImage',
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
                // "Authorization": utils.getCookie('token'),
            },
        })
    },
    uploadImgByUrl(url, data) {
        return fetch({
            method: 'post',
            url: url,
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
                // "Authorization": utils.getCookie('token'),
            },
        })
    },
    uploadPersonInfo(data) {
        return fetch({
            method: 'post',
            url: '/api/order/uploadPersonInfo',
            data: data,
            headers: {
                'Content-Type': 'multipart/form-data',
                // "Authorization": utils.getCookie('token'),
            },
        })
    },
    confirmOrder(data) {
        return fetch({
            method: 'post',
            url: api_mock + '/order/confirmOrder',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    orderSearch(data) {
        return fetch({
            method: 'post',
            url: '/api/orderQueryForPc',//'/api/order/orderSearch',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    getOrderDetail(data) {
        return fetch({
            method: 'get',
            url: '/api/order/orderinfo',
            params: data,
        })
    },
    queryTmpOrderList(data) {
        return fetch({
            method: 'get',
            url: '/api/tmpOrder/queryTmpOrderList',
            params: data,
        })
    },
    queryTmpOrderByCondition(data) {
        return fetch({
            method: 'post',
            url: '/api/tmpOrder/queryTmpOrderByCondition',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    getTmpOrderInfo(id, type) {
        let params = {
            quoteTempId: id
        }
        if(type){
            params.tempType = 1
        }

        return fetch({
            method: 'get',
            url: '/api/tmpOrder/getTmpOrderInfo/' + id,
            params,
        })
    },
    delTmpOrderInfo(data) {
        return fetch({
            method: 'post',
            url: '/api/tmpOrder/delTmpOrderInfo',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    saveUnfinishData(data) {
        return fetch({
            method: 'post',
            url: '/api/tmpOrder/submitTmpOrder',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    getOutlinePayJson(data) {
        return fetch({
            method: 'get',
            url: '/api/order/getOutlinePayJson',
            params: data,
        })
    },
    updateOutlinePayJson(data) {
        return fetch({
            method: 'post',
            url: '/api/order/updateOutlinePayJson',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    confirmInvoiceImages(data) {
        return fetch({
            method: 'post',
            url: '/api/policy/confirmInvoiceImages',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    getSalesUserByUuid(data) {
        return fetch({
            method: 'get',
            url: '/api/user/getSalesUserByUuid',
            params: data,
        })
    },
    getOrderPayUrl(data) {
        return fetch({
            method: 'get',
            url: '/api/order/orderPayUrl',
            params: data,
        })
    },
    //保全的获取支付链接
    getOrderPayUrlForConservation(data) {
        return fetch({
            method: 'get',
            url: '/api/conservation/getPayUrl',
            params: data,
        })
    },
    getOutPayUrl(data) {
        return fetch({
            method: 'get',
            url: '/api/order/getOutPayUrl',
            params: data,
        })
    },
    // 产品信息接口front.interfaceNewType不为空并且包含04字符串)
    getConfigPolicyPayUrl(data) {
        return fetch({
            method: 'get',
            url: '/api/order/getConfigPolicyPayUrl',
            params: data,
        })
    },
    updateControlInfo(data) {
        return fetch({
            method: 'post',
            url: '/adm/updateControlInfo',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },

    /** 发票申请*/
    // 获取发票信息
    getInvoiceInfo(policyUuid) {
        return fetch({
            method: 'get',
            url: '/api/invoice/getInvoiceInfo',
            params: {policyUuid},
        })
    },
    getInvoiceInfo2(data) {
        return fetch({
            method: 'get',
            url: '/api/invoice/getInvoiceInfo',
            params: data,
        })
    },
    // 发送专票申请资料邮件，还可以用于发送电子发票
    sendInvoiceMaterialEmail(emailAddress, policyUuid) {
        return fetch({
            method: 'get',
            url: '/api/invoice/sendInvoiceMaterialEmail',
            params: {emailAddress, policyUuid},
        })
    },
    // 更新专票资料
    updateInvoiceMaterialBean(data) {
        return fetch({
            method: 'post',
            url: '/api/invoice/updateInvoiceMaterialBean',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    // 申请发票
    saveInvoiceInfo(data) {
        return fetch({
            method: 'post',
            url: '/api/invoice/saveInvoiceInfo',
            data: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    // 发送电子发票
    sendEInvoiceEmail(data) {
        return fetch({
            method: 'get',
            url: '/api/invoice/sendEInvoiceEmail',
            params: data,
        })
    },

    // 获取产品的行业类型
    getIndustryInfo(productId, data) {
        return fetch({
            method: 'get',
            url: api_mock+'/getAllIndustries/' + productId,
            params: data,
        })
    },

    // 获取帮我录单数据
    getHelpMeRecordInfo(taskId) {
        return fetch({
            method: 'get',
            url: '/api/customOrder/getById/' + taskId,
            params: {},
        })
    },

    // 信息披露
    getInformationRevealList(data) {
        return fetch({
            method: 'get',
            url: '/api/getInformationRevealList',
            params: data,
        })
    },
    // 提交异常输入信息
    saveGroupWaylayRecord(data) {
        return fetch({
            method: 'post',
            url: '/api/saveGroupWaylayRecord',
            data: data,
        })
    },
    deleteBqUnfinishInfo(data) {
        return fetch({
            method: 'get',
            url: process.env.BASE_API + `/api/tempConservation/delete/${data}`,//'/api/order/orderSearch',
            params: null,
            // headers:{
            //     "Authorization": utils.getCookie('token'),
            // },
        })
    },

    queryConservationStatusNum(data) {
        return fetch({
            method: 'post',
            url: '/api/conservation/queryConservationStatusNum',
            data: data,
        })
    },

    queryConservationPolicyList(data) {
        return fetch({
            method: 'post',
            url: '/api/conservation/queryConservationPolicyList',
            data: data,
        })
    },

    queryConservationOrderDetail(data) {
        return fetch({
            method: 'get',
            url: '/api/conservation/orderDetail',
            params: data,
        })
    },
    getSettingsByPolicyUuid(data) {
        return fetch({
            method: 'get',
            url: '/api/conservation/getSettingsByPolicyUuid',
            params: data,
        })
    },
    sendECertificateMail(data) {
        return fetch({
            method: 'get',
            url: '/api/conservation/sendECertificateMail',
            params: data,
        })
    },
    getBqOutlinePayJson(data) {
        return fetch({
            method: 'get',
            url: '/api/conservation/getOutlinePayJson',
            params: data,
        })
    },
    submitOutlinePayJson(data) {
        return fetch({
            method: 'post',
            url: '/api/conservation/submitOutlinePayJson',
            data: data,
        })
    },

    queryConservationListByPolicy(data) {
        return fetch({
            method: 'get',
            url: '/api/conservation/queryConservationListByPolicy',
            params: data,
        })
    },
    getGroupInsurePolicy(data) {
        return fetch({
            method: 'get',
            url: '/api/order/getGroupInsurePolicy',
            params: data,
        })
    },

    sendBatchElectronicPolicy: function (email, uuid) {
        return fetch({
            method: 'post',
            url: '/api/order/sendBatchElectronicPolicy',
            params: {
                emailAddress: email
            },
            data: uuid
        })
    },
    getQuotedCompany(data) {
        return fetch({
            method: 'get',
            url: process.env.BASE_API + '/api/quoted/getAllCompany',
            params: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    getQuotedProductList(data) {
        return fetch({
            method: 'get',
            url: process.env.BASE_API + '/api/quoted/getProductList',
            params: data,
            // headers:{
            //   "Authorization": utils.getCookie('token'),
            // },
        })
    },
    getQuotedDeletePrice(data) {
        return fetch({
            method: 'get',
            url: '/api/quoted/deleteQuotedPrice',
            params: data,
        })
    },

    //  ocr营业执照 图片识别接口
    getRecognizeBusinessLicense(data) {
        return fetch({
          method: 'get',
          url: '/api/getRecognizeBusinessLicense',
          params: data
        })
    },
    getGroupProfessionByProductId(data) {
        return fetch({
          method: 'get',
          url: '/api/getGroupProfessionByProductId',
          params: data
        })
    },
    oauthLogin(data) {
        return fetch({
            method: 'post',
            url: '/oauth/channelLogin',
            data: data,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                // 'Authorization': utils.getCookie('token'),
            },
            transformRequest: [function (data) {
                // Do whatever you want to transform the data
                let ret = ''
                for (let it in data) {
                    ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it]) + '&'
                }
                return ret
            }],
        })
    },
    getDeclarationOcrStatus (data) {
        return fetch({
            method: 'post',
            url: '/api/getDeclarationOcrStatus',
            data
        })
    },
    checkCompanyInfo(params) {
        return fetch({
            method: 'get',
            url: '/common/checkCompanyInfo',
            params
        })
    },
}



// WEBPACK FOOTER //
// ./src/api/index.js